module.exports = __webpack_public_path__ + "static/media/laxmiraj-banner3.989c6e8f.png";